import {
  loading,
  failed,
  userJoin,
  userUpdated,
  userverified,
  userLoaded,
  userSocialJoin,
  priceAlertCreated,
  logout,
  priceAlertLoaded,
  priceAlertRemoved,
} from "./clientSlice";
import Axios from "axios";
import {
  clientJoinUrl,
  loadClientUrl,
  updateClientUrl,
  verifyClientUrl,
  clientSocialJoinUrl,
  addPriceAlertUrl,
  loadPriceAlertUrl,
  unsubscribePriceAlertUrl,
} from "./apis";

const unwrapPayload = (response: any) => {
  if (response && typeof response === "object" && "data" in response) {
    if (response.data && typeof response.data === "object" && "data" in response.data) {
      return response.data.data;
    }
    return response.data;
  }
  return response;
};

export const loadClient = () => (dispatch: any) => {
  dispatch(loading());
  Axios.get(loadClientUrl, tokenConfig())
    .then((res) => {
      dispatch(userLoaded(unwrapPayload(res.data)));
    })
    .catch((err) => {
      dispatch(failed(err));
    });
};

export const loadPriceAlert = () => (dispatch: any) => {
  dispatch(loading());
  Axios.get(loadPriceAlertUrl, tokenConfig())
    .then((res) => {
      dispatch(priceAlertLoaded(unwrapPayload(res.data)));
    })
    .catch((err) => {
      dispatch(failed(err));
    });
};
export const joinClient =
  (body: any, func: any, errFunc: any) => (dispatch: any) => {
    dispatch(loading());
    Axios.post(clientJoinUrl, body)
      .then((res) => {
        dispatch(userJoin({ data: unwrapPayload(res.data), email: body.email }));
        func();
      })
      .catch((err) => {
        dispatch(failed(err));
        errFunc();
      });
  };

export const addPriceAlert =
  (body: any, func: any, errFunc: any) => (dispatch: any) => {
    dispatch(loading());
    Axios.post(addPriceAlertUrl, body, tokenConfig())
      .then((res) => {
        dispatch(priceAlertCreated(unwrapPayload(res.data)));
        dispatch(loadPriceAlert());
        func();
      })
      .catch((err) => {
        dispatch(failed(err));
        errFunc();
      });
  };
export const removePriceAlert =
  (id: any, func: any, errFunc: any) => (dispatch: any) => {
    dispatch(loading());
    Axios.delete(unsubscribePriceAlertUrl + id, tokenConfig())
      .then((res) => {
        dispatch(priceAlertRemoved(unwrapPayload(res.data)));
        dispatch(loadPriceAlert());
        func();
      })
      .catch((err) => {
        dispatch(failed(err));
        errFunc();
      });
  };
export const joinSocialClient =
  (body: any, func: any, errFunc: any) => (dispatch: any) => {
    dispatch(loading());
    Axios.post(clientSocialJoinUrl, body)
      .then((res) => {
        const payload = unwrapPayload(res.data);
        dispatch(userSocialJoin(payload));
        func(payload);
      })
      .catch((err) => {
        dispatch(failed(err));
        errFunc();
      });
  };
export const verifyClient =
  (body: any, func: any, errFunc: any) => (dispatch: any) => {
    dispatch(loading());
    Axios.post(verifyClientUrl, body)
      .then((res) => {
        const payload = unwrapPayload(res.data);
        dispatch(userverified(payload));
        func(payload);
      })
      .catch((err) => {
        dispatch(failed(err));
        errFunc();
      });
  };
export const updateClient =
  (body: any, func: any, errFunc: any) => (dispatch: any) => {
    dispatch(loading());
    Axios.post(updateClientUrl, body, tokenConfig())
      .then((res) => {
        const payload = unwrapPayload(res.data);
        dispatch(userUpdated(payload));
        func(payload);
      })
      .catch((err) => {
        dispatch(failed(err));
        errFunc();
      });
  };
export const logoutClient = () => (dispatch: any) => {
  dispatch(logout());
};
export const tokenConfig = () => {
  const token = localStorage.getItem("svToken");
  const config: any = {
    headers: {
      // "Content-Type": "application/json",
    },
  };
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};
